import angular from 'angular';

import BuyerAddresses from './buyer-addresses.ctrl';
import BuyerSpecialPricings from './buyer-special-pricings.ctrl';
import CompanyCommonWords from './company-common-words.ctrl';
import DemandCreateEdit from './demand-create-edit.ctrl';
import DemandManage from './demand-manage.ctrl';
import FaqManage from './faq-manage.ctrl';
import ItemDialog from './item-dialog.ctrl';
import MessageCenter from './message-center.ctrl';
import OfferActivatePriceDialog from './offer-activate-price-dialog.ctrl';
import OfferCampaignAttachments from './offer-campaign-attachments.ctrl';
import OfferCampaignBasicInfos from './offer-campaign-basic-infos.ctrl';
import OfferCampaignCreateDialog from './offer-campaign-create-dialog.ctrl';
import OfferCampaignCreate from './offer-campaign-create.ctrl';
import OfferCampaignFields from './offer-campaign-fields.ctrl';
import OfferCampaignMassSendDialog from './offer-campaign-mass-send-dialog.ctrl';
import OfferCampaignMassSendReport from './offer-campaign-mass-send-report.ctrl';
import OfferStocklistMassUpdateDialog from './offer-stocklist-mass-update-dialog.ctrl';
import OfferCampaignProductSpec from './offer-campaign-product-spec.ctrl';
import OfferCampaignRecipientAttachmentsDialog from './offer-campaign-recipient-attachments-dialog.ctrl';
import OfferCampaignRecipientsDialog from './offer-campaign-recipients-dialog.ctrl';
import OfferCampaignRecipientsPendingGeneral from './offer-campaign-recipients-pending-general.ctrl';
import OfferCampaignRecipientsPendingSpecial from './offer-campaign-recipients-pending-special.ctrl';
import OfferCampaignRecipientsSent from './offer-campaign-recipients-sent.ctrl';
import OfferCampaignRecipients from './offer-campaign-recipients.ctrl';
import OfferCampaignSettings from './offer-campaign-settings.ctrl';
import OfferCampaign from './offer-campaign.ctrl';
import OfferCampaigns from './offer-campaigns.ctrl';
import OfferCharges from './offer-charges.ctrl';
import OfferConnectionsItem from './offer-connections-item.ctrl';
import OfferConnections from './offer-connections.ctrl';
import OfferCreate from './offer-create.ctrl';
import OfferEditCampaigns from './offer-edit-campaigns.ctrl';
import OfferEdit from './offer-edit.ctrl';
import OfferInventories from './offer-inventories.ctrl';
import OfferMainBasic from './offer-main-basic.ctrl';
import OfferMainDescription from './offer-main-description.ctrl';
import OfferMainTitle from './offer-main-title.ctrl';
import OfferMarketRestrictions from './offer-market-restrictions.ctrl';
import OfferMatchingAnalysis from './offer-matching-analysis.ctrl';
import OfferCutAnalysis from './offer-cut-analysis.ctrl';
import OfferMatchingCriteria from './offer-matching-criteria.ctrl';
import OfferMatching from './offer-matching.ctrl';
import OfferOsppUsers from './offer-ospp-users.ctrl';
import OfferRequestCreate from './offer-request-create.ctrl';
import OfferRequestItemDialog from './offer-request-item-dialog.ctrl';
import OfferRequestItemTabs from './offer-request-item-tabs.ctrl';
import OfferRequestItems from './offer-request-items.ctrl';
import OfferRequests from './offer-requests.ctrl';
import OfferSectionMenu from './offer-section-menu.ctrl';
import OfferSidebarMenu from './offer-sidebar-menu.ctrl';
import OfferStockItemPriceDialog from './offer-stock-item-price-dialog.ctrl';
import OfferStocklistCriteria from './offer-stocklist-criteria.ctrl';
import OfferStocklist from './offer-stocklist.ctrl';
import OfferSupplierPricing from './offer-supplier-pricing.ctrl';
import OfferUpload from './offer-upload.ctrl';
import Offers from './offers.ctrl';
import OrderArrivals from './order-arrivals.ctrl';
import OrderAttachments from './order-attachments.ctrl';
import OrderBookingNoteNotifications from './order-booking-note-notifications.ctrl';
import OrderBookingNotes from './order-booking-notes.ctrl';
import OrderBuyerDetails from './order-buyer-details.ctrl';
import OrderCreate from './order-create.ctrl';
import OrderDeliveryGeneral from './order-delivery-general.ctrl';
import OrderDocumentsContacts from './order-documents-contacts.ctrl';
import OrderDocuments from './order-documents.ctrl';
import OrderMainDocs from './order-main-docs.ctrl';
import OrderMainInfos from './order-main-infos.ctrl';
import OrderManage from './order-manage.ctrl';
import OrderNotifications from './order-notifications.ctrl';
import OrderOverview from './order-overview.ctrl';
import OrderPaymentGeneral from './order-payment-general.ctrl';
import OrderPayments from './order-payments.ctrl';
import OrderSellerDetails from './order-seller-details.ctrl';
import OrderSidebar from './order-sidebar.ctrl';
import OrderStocklist from './order-stocklist.ctrl';
import OrderUpload from './order-upload.ctrl';
import PendingImportCheck from './pending-import-check.ctrl';
import PendingRegistrationCheck from './pending-registration-check.ctrl';
import PendingRegistrationView from './pending-registration-view.ctrl';
import ProductBrands from './product-brands.ctrl';
import ProductCategoryGroupsDialog from './product-category-groups-dialog.ctrl';
import ProductCategorySpecsGroupsDialog from './product-category-specs-groups-dialog.ctrl';
import ProductExport from './product-export.ctrl';
import ProductGroupSpecRanges from './product-group-spec-ranges.ctrl';
import ProductGroupSpecsDialog from './product-group-specs-dialog.ctrl';
import ProductGroupSpecs from './product-group-specs.ctrl';
import ProductEndUsesAddDialog from './product-end-uses-add-dialog.ctrl';
import ProductEndUsesAdd from './product-end-uses-add.ctrl';
import ProductEndUsesManage from './product-end-uses-manage.ctrl';
import ProductEndUses from './product-end-uses.ctrl';
import ProductGroups from './product-groups.ctrl';
import ProductImport from './product-import.ctrl';
import ProductPriceGroup from './product-price-group.ctrl';
import ProductPriceGroups from './product-price-groups.ctrl';
import StocklistSpecsEdit from './stocklist-specs-edit.ctrl';
import StocklistSpecs from './stocklist-specs.ctrl';
import SupplierProductPricings from './supplier-product-pricings.ctrl';
import UserAcceptablePaymentTerms from './user-acceptable-payment-terms.ctrl';
import UserBuyerEdit from './user-buyer-edit.ctrl';
import UserBuyerSectionMenu from './user-buyer-section-menu.ctrl';
import UserBuyerSidebarMenu from './user-buyer-sidebar-menu.ctrl';
import UserContactNotificationsDialog from './user-contact-notifications-dialog.ctrl';
import UserContacts from './user-contacts.ctrl';
import UserCountryCharges from './user-country-charges.ctrl';
import UserCreate from './user-create.ctrl';
import UserDeliveryTerm from './user-delivery-term.ctrl';
import UserDeliveryTerms from './user-delivery-terms.ctrl';
import UserDetails from './user-details.ctrl';
import UserEditCampaigns from './user-edit-campaigns.ctrl';
import UserExport from './user-export.ctrl';
import UserFaqs from './user-faqs.ctrl';
import UserFreightRatesExport from './user-freight-rates-export';
import UserFreightRatesImport from './user-freight-rates-import';
import UserFreightRates from './user-freight-rates.ctrl';
import UserImport from './user-import.ctrl';
import UserIncotermCharges from './user-incoterm-charges.ctrl';
import UserManageCities from './user-manage-cities.ctrl';
import UserManageCompanies from './user-manage-companies.ctrl';
import UserManageContacts from './user-manage-contacts.ctrl';
import UserManageEmailHostnames from './user-manage-email-hostnames.ctrl';
import UserManageMembers from './user-manage-members.ctrl';
import UserMarketRestrictions from './user-market-restrictions.ctrl';
import UserRestrictedTo from './user-restricted-to.ctrl';
import UserOfferMatching from './user-offer-matching.ctrl';
import UserOfferRequestItems from './user-offer-request-items.ctrl';
import UserOffers from './user-offers.ctrl';
import UserOrders from './user-orders.ctrl';
import UserOverview from './user-overview.ctrl';
import UserProductBrandPricing from './user-product-brand-pricing.ctrl';
import UserProductCopyFromUserDialog from './user-product-copy-from-user-dialog.ctrl';
import UserProductCopySpecs from './user-product-copy-specs.ctrl';
import UserProductEditSpecs from './user-product-edit-specs.ctrl';
import UserProductEndUses from './user-product-end-uses.ctrl';
import UserProductGroupCharges from './user-product-group-charges.ctrl';
import UserProductGroupSettings from './user-product-group-settings.ctrl';
import UserProductGroupSpecs from './user-product-group-specs.ctrl';
import UserProductMassSpecs from './user-product-mass-specs.ctrl';
import UserProductPreview from './user-product-preview.ctrl';
import UserProductPricing from './user-product-pricing.ctrl';
import UserProductPricings from './user-product-pricings.ctrl';
import UserProductSpecGroups from './user-product-spec-groups.ctrl';
import UserProductSpecialPricings from './user-product-special-pricings.ctrl';
import UserProductSpecs from './user-product-specs.ctrl';
import UserProductTargetPricings from './user-product-target-pricings.ctrl';
import UserProductViewSpecs from './user-product-view-specs.ctrl';
import UserProducts from './user-products.ctrl';
import UserRegister from './user-register.ctrl';
import UserRollMessages from './user-roll-messages.ctrl';
import UserSellerEdit from './user-seller-edit.ctrl';
import UserSellerSectionMenu from './user-seller-section-menu.ctrl';
import UserSellerSidebarMenu from './user-seller-sidebar-menu.ctrl';
import UserSpecialPaymentTerms from './user-special-payment-terms.ctrl';
import UserTradingDetails from './user-trading-details.ctrl';
import UserTradingOffer from './user-trading-offer.ctrl';
import UserTradingOrderBuyer from './user-trading-order-buyer.ctrl';
import UserTradingOrderSeller from './user-trading-order-seller.ctrl';
import UserViewSimilar from './user-view-similar.ctrl';
import UsersByGroup from './users-by-group.ctrl';
import UsersByRelation from './users-by-relation.ctrl';
import Users from './users.ctrl';
import Mills from './mills.ctrl';
import MillsAdd from './mills-add.ctrl';
import MillsEdit from './mills-edit.ctrl';
import Newsletter from './newsletter.ctrl';
import Newsletters from './newsletters.ctrl';
import NewsletterCreate from './newsletter-create.ctrl';
import NewsletterRecipients from './newsletter-recipients.ctrl';
import NewsletterRecipientsPending from './newsletter-recipients-pending.ctrl';
import NewsletterRecipientsSent from './newsletter-recipients-sent.ctrl';
import Messages from './messages.ctrl';
import MessageCreate from './message-create.ctrl';
import MessageUpdate from './message-update.ctrl';
import WebGlossaries from './web-glossaries.ctrl';
import WebSources from './web-sources.ctrl';
import WebSourcesAdd from './web-sources-add.ctrl';
import WebSourcesEdit from './web-sources-edit.ctrl';
import WebSourcesCategories from './web-sources-categories.ctrl';
import WebEvents from './web-events.ctrl';
import WebEventsAdd from './web-events-add.ctrl';
import WebEventsEdit from './web-events-edit.ctrl';
import WebNews from './web-news.ctrl';
import WebNewsCategories from './web-news-categories.ctrl';
import WebTopics from './web-topics.ctrl';
import WebTopicsCategories from './web-topics-categories.ctrl';

const app = angular.module('app.admin');

app.controller('BuyerAddresses', BuyerAddresses);
app.controller('BuyerSpecialPricings', BuyerSpecialPricings);
app.controller('CompanyCommonWords', CompanyCommonWords);
app.controller('DemandCreateEdit', DemandCreateEdit);
app.controller('DemandManage', DemandManage);
app.controller('FaqManage', FaqManage);
app.controller('ItemDialog', ItemDialog);
app.controller('MessageCenter', MessageCenter);
app.controller('OfferActivatePriceDialog', OfferActivatePriceDialog);
app.controller('OfferCampaignAttachments', OfferCampaignAttachments);
app.controller('OfferCampaignBasicInfos', OfferCampaignBasicInfos);
app.controller('OfferCampaignCreateDialog', OfferCampaignCreateDialog);
app.controller('OfferCampaignCreate', OfferCampaignCreate);
app.controller('OfferCampaignFields', OfferCampaignFields);
app.controller('OfferCampaignMassSendDialog', OfferCampaignMassSendDialog);
app.controller('OfferCampaignMassSendReport', OfferCampaignMassSendReport);
app.controller('OfferStocklistMassUpdateDialog', OfferStocklistMassUpdateDialog);
app.controller('OfferCampaignProductSpec', OfferCampaignProductSpec);
app.controller('OfferCampaignRecipientAttachmentsDialog', OfferCampaignRecipientAttachmentsDialog);
app.controller('OfferCampaignRecipientsDialog', OfferCampaignRecipientsDialog);
app.controller('OfferCampaignRecipientsPendingGeneral', OfferCampaignRecipientsPendingGeneral);
app.controller('OfferCampaignRecipientsPendingSpecial', OfferCampaignRecipientsPendingSpecial);
app.controller('OfferCampaignRecipientsSent', OfferCampaignRecipientsSent);
app.controller('OfferCampaignRecipients', OfferCampaignRecipients);
app.controller('OfferCampaignSettings', OfferCampaignSettings);
app.controller('OfferCampaign', OfferCampaign);
app.controller('OfferCampaigns', OfferCampaigns);
app.controller('OfferCharges', OfferCharges);
app.controller('OfferConnectionsItem', OfferConnectionsItem);
app.controller('OfferConnections', OfferConnections);
app.controller('OfferCreate', OfferCreate);
app.controller('OfferEditCampaigns', OfferEditCampaigns);
app.controller('OfferEdit', OfferEdit);
app.controller('OfferInventories', OfferInventories);
app.controller('OfferMainBasic', OfferMainBasic);
app.controller('OfferMainDescription', OfferMainDescription);
app.controller('OfferMainTitle', OfferMainTitle);
app.controller('OfferMarketRestrictions', OfferMarketRestrictions);
app.controller('OfferMatchingAnalysis', OfferMatchingAnalysis);
app.controller('OfferCutAnalysis', OfferCutAnalysis);
app.controller('OfferMatchingCriteria', OfferMatchingCriteria);
app.controller('OfferMatching', OfferMatching);
app.controller('OfferOsppUsers', OfferOsppUsers);
app.controller('OfferRequestCreate', OfferRequestCreate);
app.controller('OfferRequestItemDialog', OfferRequestItemDialog);
app.controller('OfferRequestItemTabs', OfferRequestItemTabs);
app.controller('OfferRequestItems', OfferRequestItems);
app.controller('OfferRequests', OfferRequests);
app.controller('OfferSectionMenu', OfferSectionMenu);
app.controller('OfferSidebarMenu', OfferSidebarMenu);
app.controller('OfferStockItemPriceDialog', OfferStockItemPriceDialog);
app.controller('OfferStocklistCriteria', OfferStocklistCriteria);
app.controller('OfferStocklist', OfferStocklist);
app.controller('OfferSupplierPricing', OfferSupplierPricing);
app.controller('OfferUpload', OfferUpload);
app.controller('Offers', Offers);
app.controller('OrderArrivals', OrderArrivals);
app.controller('OrderAttachments', OrderAttachments);
app.controller('OrderBookingNoteNotifications', OrderBookingNoteNotifications);
app.controller('OrderBookingNotes', OrderBookingNotes);
app.controller('OrderBuyerDetails', OrderBuyerDetails);
app.controller('OrderCreate', OrderCreate);
app.controller('OrderDeliveryGeneral', OrderDeliveryGeneral);
app.controller('OrderDocumentsContacts', OrderDocumentsContacts);
app.controller('OrderDocuments', OrderDocuments);
app.controller('OrderMainDocs', OrderMainDocs);
app.controller('OrderMainInfos', OrderMainInfos);
app.controller('OrderManage', OrderManage);
app.controller('OrderNotifications', OrderNotifications);
app.controller('OrderOverview', OrderOverview);
app.controller('OrderPaymentGeneral', OrderPaymentGeneral);
app.controller('OrderPayments', OrderPayments);
app.controller('OrderSellerDetails', OrderSellerDetails);
app.controller('OrderSidebar', OrderSidebar);
app.controller('OrderStocklist', OrderStocklist);
app.controller('OrderUpload', OrderUpload);
app.controller('PendingImportCheck', PendingImportCheck);
app.controller('PendingRegistrationCheck', PendingRegistrationCheck);
app.controller('PendingRegistrationView', PendingRegistrationView);
app.controller('ProductBrands', ProductBrands);
app.controller('ProductCategoryGroupsDialog', ProductCategoryGroupsDialog);
app.controller('ProductCategorySpecsGroupsDialog', ProductCategorySpecsGroupsDialog);
app.controller('ProductExport', ProductExport);
app.controller('ProductGroupSpecRanges', ProductGroupSpecRanges);
app.controller('ProductGroupSpecsDialog', ProductGroupSpecsDialog);
app.controller('ProductGroupSpecs', ProductGroupSpecs);
app.controller('ProductEndUsesAddDialog', ProductEndUsesAddDialog);
app.controller('ProductEndUsesAdd', ProductEndUsesAdd);
app.controller('ProductEndUsesManage', ProductEndUsesManage);
app.controller('ProductEndUses', ProductEndUses);
app.controller('ProductGroups', ProductGroups);
app.controller('ProductImport', ProductImport);
app.controller('ProductPriceGroup', ProductPriceGroup);
app.controller('ProductPriceGroups', ProductPriceGroups);
app.controller('StocklistSpecsEdit', StocklistSpecsEdit);
app.controller('StocklistSpecs', StocklistSpecs);
app.controller('SupplierProductPricings', SupplierProductPricings);
app.controller('UserAcceptablePaymentTerms', UserAcceptablePaymentTerms);
app.controller('UserBuyerEdit', UserBuyerEdit);
app.controller('UserBuyerSectionMenu', UserBuyerSectionMenu);
app.controller('UserBuyerSidebarMenu', UserBuyerSidebarMenu);
app.controller('UserContactNotificationsDialog', UserContactNotificationsDialog);
app.controller('UserContacts', UserContacts);
app.controller('UserCountryCharges', UserCountryCharges);
app.controller('UserCreate', UserCreate);
app.controller('UserDeliveryTerm', UserDeliveryTerm);
app.controller('UserDeliveryTerms', UserDeliveryTerms);
app.controller('UserDetails', UserDetails);
app.controller('UserEditCampaigns', UserEditCampaigns);
app.controller('UserExport', UserExport);
app.controller('UserFaqs', UserFaqs);
app.controller('UserFreightRatesExport', UserFreightRatesExport);
app.controller('UserFreightRatesImport', UserFreightRatesImport);
app.controller('UserFreightRates', UserFreightRates);
app.controller('UserImport', UserImport);
app.controller('UserIncotermCharges', UserIncotermCharges);
app.controller('UserManageCities', UserManageCities);
app.controller('UserManageCompanies', UserManageCompanies);
app.controller('UserManageContacts', UserManageContacts);
app.controller('UserManageEmailHostnames', UserManageEmailHostnames);
app.controller('UserManageMembers', UserManageMembers);
app.controller('UserMarketRestrictions', UserMarketRestrictions);
app.controller('UserRestrictedTo', UserRestrictedTo);
app.controller('UserOfferMatching', UserOfferMatching);
app.controller('UserOfferRequestItems', UserOfferRequestItems);
app.controller('UserOffers', UserOffers);
app.controller('UserOrders', UserOrders);
app.controller('UserOverview', UserOverview);
app.controller('UserProductBrandPricing', UserProductBrandPricing);
app.controller('UserProductCopyFromUserDialog', UserProductCopyFromUserDialog);
app.controller('UserProductCopySpecs', UserProductCopySpecs);
app.controller('UserProductEditSpecs', UserProductEditSpecs);
app.controller('UserProductEndUses', UserProductEndUses);
app.controller('UserProductGroupCharges', UserProductGroupCharges);
app.controller('UserProductGroupSettings', UserProductGroupSettings);
app.controller('UserProductGroupSpecs', UserProductGroupSpecs);
app.controller('UserProductMassSpecs', UserProductMassSpecs);
app.controller('UserProductPreview', UserProductPreview);
app.controller('UserProductPricing', UserProductPricing);
app.controller('UserProductPricings', UserProductPricings);
app.controller('UserProductSpecGroups', UserProductSpecGroups);
app.controller('UserProductSpecialPricings', UserProductSpecialPricings);
app.controller('UserProductSpecs', UserProductSpecs);
app.controller('UserProductTargetPricings', UserProductTargetPricings);
app.controller('UserProductViewSpecs', UserProductViewSpecs);
app.controller('UserProducts', UserProducts);
app.controller('UserRegister', UserRegister);
app.controller('UserRollMessages', UserRollMessages);
app.controller('UserSellerEdit', UserSellerEdit);
app.controller('UserSellerSectionMenu', UserSellerSectionMenu);
app.controller('UserSellerSidebarMenu', UserSellerSidebarMenu);
app.controller('UserSpecialPaymentTerms', UserSpecialPaymentTerms);
app.controller('UserTradingDetails', UserTradingDetails);
app.controller('UserTradingOffer', UserTradingOffer);
app.controller('UserTradingOrderBuyer', UserTradingOrderBuyer);
app.controller('UserTradingOrderSeller', UserTradingOrderSeller);
app.controller('UserViewSimilar', UserViewSimilar);
app.controller('UsersByGroup', UsersByGroup);
app.controller('UsersByRelation', UsersByRelation);
app.controller('Users', Users);
app.controller('Mills', Mills);
app.controller('MillsAdd', MillsAdd);
app.controller('MillsEdit', MillsEdit);
app.controller('Newsletter', Newsletter);
app.controller('Newsletters', Newsletters);
app.controller('NewsletterCreate', NewsletterCreate);
app.controller('NewsletterRecipients', NewsletterRecipients);
app.controller('NewsletterRecipientsPending', NewsletterRecipientsPending);
app.controller('NewsletterRecipientsSent', NewsletterRecipientsSent);
app.controller('Messages', Messages);
app.controller('MessageCreate', MessageCreate);
app.controller('MessageUpdate', MessageUpdate);
app.controller('WebGlossaries', WebGlossaries);
app.controller('WebSources', WebSources);
app.controller('WebSourcesAdd', WebSourcesAdd);
app.controller('WebSourcesEdit', WebSourcesEdit);
app.controller('WebSourcesCategories', WebSourcesCategories);
app.controller('WebEvents', WebEvents);
app.controller('WebEventsAdd', WebEventsAdd);
app.controller('WebEventsEdit', WebEventsEdit);
app.controller('WebNews', WebNews);
app.controller('WebNewsCategories', WebNewsCategories);
app.controller('WebTopics', WebTopics);
app.controller('WebTopicsCategories', WebTopicsCategories);



// WEBPACK FOOTER //
// ./front/js/admin/controllers/index.js